import form, { rolesForm } from "pages/account/manage/schemas/form";

const {
  formField: { displayName, designation, email, medicalID, roles },
} = form;

const initialValues = {
  [displayName.name]: "",
  [designation.name]: "",
  [email.name]: "",
  [medicalID.name]: "",
  [roles.name]: [],
};

const {
  formField: { roleName },
} = rolesForm;

const rolesInitialValues = {
  [roleName.name]: "",
};

export { initialValues as default, rolesInitialValues };
